<div class="breadcrumb-bar">
  <app-breadcrumb></app-breadcrumb>
</div>
<div class="container">
  <div class="container-flight-detail">
    <div class="details-col">
      <div class="map-container box-shadow">
        <div id="legMap" [class.dark-theme]="theme$ === 'dark'">
          <button class="map-reset-btn" (click)="onResetMap()">
            <i class="pi pi-refresh"></i>
          </button>
        </div>
      </div>
      <div *ngIf="flightLeg$ | async as leg">
        <div class="header">
          <div class="tag sequence box-shadow">{{sequenceNumber}}</div>
          @if(leg?.flightNumber === 0) {
          <div class="tag misc box-shadow">Surface/Misc. Duty</div>
          }
          <div class="c-row c-info-row">
            @if (leg && leg.oalSurfaceAirline) {
            <div class="tag-container" (click)="op.toggle($event)">
              <div class="tag oal-surface box-shadow">{{leg.oalSurfaceAirline}}</div>
            </div>
            }
            <div class="tag-container">
              @if (leg?.isCancelled && leg?.isDeadhead) {
              <div class="tag cx box-shadow">{{tag}}</div>
              }
              @else if (leg?.isDeadhead) {
              <div class="tag dh box-shadow">{{tag}}</div>
              }
              @else if (leg?.isCancelled) {
              <div class="tag cx box-shadow">{{tag}}</div>
              }
              @else {
              <div class="tag flt box-shadow">{{tag}}</div>
              }
            </div>

          </div>
        </div>
        <div class="card">
          <p-fieldset [dt]="fieldSet">
            <ng-template pTemplate="header">
              <div class="header-title">
                Flight Details
                <i class="pi pi-question-circle help-icon" style="color: var(--p-primary-600)"
                  (click)="onHelpClicked(0)">
                </i>
              </div>
            </ng-template>
            @if (leg) {
            <div class="flight-detials-col">
              @if(isTimeFormatUTC) {
              @if (leg.departure.actual && (leg.departure.actual.utc | date: 'yyyy') !== '0001') {
              <div class="row">
                <span class="row-label-color">Date</span>
                <div>{{convertDate(leg.departure.actual.utc)}}
                  <span class="timezone-tag">UTC</span>
                </div>
              </div>
              }
              @else {
              <div class="row">
                <span class="row-label-color">Date</span>
                <div>{{convertDate(leg.departure.scheduled.utc)}}
                  <span class="timezone-tag">UTC</span>
                </div>
              </div>
              }
              }
              @else {
              @if (leg.departure.actual && (leg.departure.actual.local | date: 'yyyy') !== '0001') {
              <div class="row row-label">
                <span class="row-label-color">Date</span>
                <div>{{convertDate(leg.departure.actual.local)}}
                  <span class="timezone-tag">LCL</span>
                </div>
              </div>
              }
              @else {
              <div class="row row-label">
                <span class="row-label-color">Date</span>
                <div>{{convertDate(leg.departure.scheduled.local)}}
                  <span class="timezone-tag">LCL</span>
                </div>
              </div>
              }
              }

              <div class="row">
                <span class="row-label-color">Flight #</span>
                <div>AAL{{leg.flightNumber || 0}}</div>
              </div>

              <div class="row">
                <span class="row-label-color">Aircraft Type</span>
                @if(
                leg.aircraft &&
                (leg.aircraft.type?.long != null || leg.aircraft.type?.long != undefined)) {
                <div>{{leg.aircraft.type?.long || ''}}</div>
                }
                @else {
                <div style="font-style: italic; color: var(--p-surface-500)">unknown</div>
                }
              </div>
              <div class="row">
                <span class="row-label-color">Registration</span>
                @if(
                leg.aircraft &&
                (leg.aircraft.faa != null || leg.aircraft.faa != undefined)) {
                <div class="reg-label" (click)="onRegClicked(leg.aircraft)">{{leg.aircraft.faa || ''}}</div>
                }
                @else {
                <div style="font-style: italic; color: var(--p-surface-500)">unknown</div>
                }

              </div>

              <div class="row row-label">
                <span class="row-label-color">Aircraft Nose #</span>
                @if(
                leg.aircraft &&
                (leg.aircraft.id != null || leg.aircraft.id != undefined)) {
                <div>
                  @if(validateAircraftId(leg.aircraft.id) === 'unknown') {
                  <div style="font-style: italic; color: var(--p-surface-500)">unknown</div>
                  }
                  @else {
                  {{validateAircraftId(leg.aircraft.id)}}
                  }
                </div>
                }
                @else {
                <div style="font-style: italic; color: var(--p-surface-500)">unknown</div>
                }
              </div>

              <div class="row">
                <div class="station-row row-label">
                  <span class="row-label-color">Departure</span>
                  <img style="width: 20px; height: 20px"
                    [src]="theme$ === 'light' ? takeOffIconLight:takeOffIconDark" />
                </div>
                <div class="station-label">{{leg.departureStation.code}}</div>
              </div>
              <div class="row">
                <div class="station-row row-label">
                  <span class="row-label-color">Arrival</span>
                  <img style="width: 20px; height: 20px"
                    [src]="theme$ === 'light' ? landingIconLight:landingIconDark" />
                </div>
                <div class="station-label">{{leg.arrivalStation.code}}</div>
              </div>

              <div class="row row-label">
                <span class="row-label-color">Distance</span>
                <div>{{leg.flightDistance | convertDistance }}nm</div>
              </div>
              @if (!leg.isDeadhead) {
              <div class="row row-label">
                <span class="row-label-color">Passenger Count</span>
                <div>{{leg.passengerCount}}</div>
              </div>
              }
            </div>

            }
          </p-fieldset>

          <p-fieldset [dt]="fieldSet">
            <ng-template pTemplate="header">
              <div class="header-title">
                Flight Times
                <i class="pi pi-question-circle help-icon" (click)="onHelpClicked(1)"></i>
              </div>
            </ng-template>


            @if (leg) {
            <div class="flight-times-row">
              <!-- TIME LABEL COLUMN -->
              <div class="flt-time-col">

                <div class="sch-row-label">
                  Sched
                </div>

                @if ( (leg.departure.rescheduled.local | date: 'yyyy') !== '0001'||
                (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                <div class="sch-row-label">ReSched</div>
                }


                @if (+leg.flightTimeActual !== 0) {
                <div class="row-label">
                  <span class="row-label-color">Actual</span>
                </div>
                }
              </div>

              <!-- OUT  COLUMN-->
              <div class="flt-time-col">
                <!-- UTC Time Default Set-->
                <div class="header-row">Out</div>
                @if(isTimeFormatUTC) {
                <!-- Scheduled -->
                <div class="sch-row-label">
                  {{leg.departure.scheduled.utc| formatTime }}Z

                  @if(leg.departure.scheduled.local){
                  <small>({{leg.departure.scheduled.local | formatTime}}L)</small>
                  }
                  @else {<div class="empty-block"></div>}
                </div>
                <!-- Rescheduled -->
                @if ((leg.departure.rescheduled.local | date: 'yyyy') !== '0001' &&
                (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                <div class="sch-row-label">
                  {{leg.departure.rescheduled.utc| formatTime }}Z
                  @if(leg.departure.rescheduled.local){
                  <small>({{leg.departure.rescheduled.local | formatTime}}L)</small>
                  }
                </div>
                }
                @else if ((leg.arrival.rescheduled.utc | date: 'yyyy') !== '0001') {
                <div class="empty-block"></div>
                }
                <!-- Actual -->
                @if (leg.departure.actual.local && leg.departure.actual.utc && +leg.flightTimeActual !== 0) {
                <div class="row-label">{{leg.departure.actual.utc | formatTime}}Z
                  <small>({{leg.departure.actual.local | formatTime}}L)</small>
                </div>
                }
                }
                <!-- LOCAL Time Default Set -->
                @else {
                <!-- Scheduled -->
                <div class="sch-row-label">
                  {{leg.departure.scheduled.local| formatTime }}L

                  @if(leg.departure.scheduled.utc){
                  <small>({{leg.departure.scheduled.utc | formatTime}}Z)</small>
                  }
                  @else {<div class="empty-block"></div>}
                </div>
                <!-- Rescheduled -->
                @if ((leg.departure.rescheduled.local | date: 'yyyy') !== '0001' &&
                (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                <div class="sch-row-label">
                  {{leg.departure.rescheduled.local| formatTime }}L
                  @if(leg.departure.rescheduled.utc){
                  <small>({{leg.departure.rescheduled.utc | formatTime}}Z)</small>
                  }
                </div>
                }
                @else if ((leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                <div class="empty-block"></div>
                }
                <!-- Actual -->
                @if (leg.departure.actual.local && leg.departure.actual.utc && +leg.flightTimeActual !== 0) {
                <div class="row-label">{{leg.departure.actual.local | formatTime}}L
                  <small>({{leg.departure.actual.utc | formatTime}}Z)</small>
                </div>
                }
                }
              </div>

              <!-- IN COLUMN -->
              <div class="flt-time-col">
                <!-- UTC Time Defuault Set -->
                <div class="header-row">In</div>
                @if(isTimeFormatUTC) {
                <!-- Scheduled -->
                <div class="sch-row-label">
                  {{leg.arrival.scheduled.utc| formatTime}}Z

                  @if (leg.arrival.scheduled.local) {
                  <small>({{leg.arrival.scheduled.local | formatTime}}L)</small>
                  }
                </div>
                <!-- Rescheduled -->
                @if ((leg.arrival.rescheduled.local | date: 'yyyy') !== '0001' &&
                (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                <div class="sch-row-label">
                  {{leg.arrival.rescheduled.utc| formatTime}}Z
                  @if (leg.arrival.rescheduled.local) {
                  <small>({{leg.arrival.rescheduled.local | formatTime}}L)</small>
                  }
                </div>
                }
                @else if ((leg.departure.rescheduled.utc | date: 'yyyy') !== '0001') {
                <div class="empty-block"></div>
                }
                <!-- Actual -->
                @if (leg.arrival.actual.local && leg.arrival.actual.utc && +leg.flightTimeActual !== 0) {
                <div class="row-label">{{leg.arrival.actual.utc | formatTime}}Z
                  <small>({{leg.arrival.actual.local | formatTime}}L)</small>
                </div>
                }
                }
                <!-- LOCAL Time Default Set -->
                @else {
                <!-- Scheduled -->
                <div class="sch-row-label">
                  {{leg.arrival.scheduled.local| formatTime}}L

                  @if (leg.arrival.scheduled.utc) {
                  <small>({{leg.arrival.scheduled.utc | formatTime}}Z)</small>
                  }
                </div>
                <!-- Rescheduled  -->
                @if ((leg.arrival.rescheduled.local | date: 'yyyy') !== '0001' &&
                (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                <div class="sch-row-label">
                  {{leg.arrival.rescheduled.local| formatTime}}L
                  @if (leg.arrival.rescheduled.utc) {
                  <small>({{leg.arrival.rescheduled.utc | formatTime}}Z)</small>
                  }
                </div>
                }
                @else if ((leg.departure.rescheduled.local | date: 'yyyy') !== '0001') {
                <div class="empty-block"></div>
                }
                <!-- Actual -->
                @if (leg.arrival.actual.local && leg.arrival.actual.utc && +leg.flightTimeActual !== 0) {
                <div class="row-label">{{leg.arrival.actual.local | formatTime}}L
                  <small>({{leg.arrival.actual.utc | formatTime}}Z)</small>
                </div>
                }
                }
              </div>
              <!-- BLOCK -->
              <div class="flt-time-col alt-col">

                <div class="header-row">Block</div>

                <div class="sch-row-label">{{leg.flightTimeScheduled | formatMinutes }}</div>

                @if ((leg.departure.rescheduled.local| date: 'yyyy') !== '0001' ||
                (leg.arrival.rescheduled.local| date: 'yyyy') !== '0001') {
                <div class="sch-row-label">{{leg.flightTimeScheduled | formatMinutes}}</div>
                }

                @if(leg.flightTimeActual) {
                <div class="row-label">{{leg.flightTimeActual | formatMinutes }}</div>
                }
                <!-- @else {<div class="empty-block"></div>} -->
              </div>
            </div>
            }
          </p-fieldset>

          <p-fieldset [dt]="fieldSet">
            <ng-template pTemplate="header">
              <div class="header-title">
                Pilots
              </div>
            </ng-template>

            <div *ngIf="crewMembers$ | async as crewMembers">
              @if(crewMembers.response && crewMembers.response.length > 0) {
              <div *ngFor="let crew of crewMembers.response">
                <div class="c-block-row">
                  <div class="pilots-col c-col">
                    <div class="c-info-row c-row">
                      <div class="c-seat-col c-col">
                        <div>{{crew.seat}}</div>
                      </div>

                      <div class="c-name-col">
                        <div class="c-name-row">
                          {{crew.firstName}}
                          @if(crew.nickName && crew.nickName !== crew.firstName) {
                          <span>({{crew.nickName}})</span>
                          }
                          {{crew.lastName}}
                        </div>
                        <div class="c-empNum-row">{{crew.username}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="c-contact-col c-col">
                    <div class="c-info-row c-row">
                      <div class="img-container" (click)="onContactCrew(crew)">
                        <img style="height: 34px; width: 34px;" [src]="theme$ === 'light' ? contactLight:contactDark" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
              @else {
              <div class="c-not-found">Pilots Not Found</div>
              }
            </div>
          </p-fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
<p-popover class="deadhead-airline-popover" #op>
  <div>
    <div class="c-col">
      <div class="title-overlay">
        Deadhead Airline
      </div>
      <div class="c-row left">
        <div class="code">
          {{oalCode}}:
        </div>
        <div class="reason-code-description">
          {{airlineCodes[oalCode || 'unknown']}}
        </div>
      </div>
      @if (oalCode !== 'AA') {
      <div class="popover-footer">Actual flight times not available for Deadhead on 'Other Airlines'.</div>
      }
    </div>
  </div>
</p-popover>